<template>
    <div class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow duration-200">
        <div class="flex items-start justify-between">
            <div class="flex-1">
                <div class="flex items-center gap-2 mb-2">
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                        :class="getTypeColor(news.type)">
                        {{ getTypeLabel(news.type) }}
                    </span>
                    <span class="text-xs text-gray-500">{{ news.entity }}</span>
                </div>

                <h4 class="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                    {{ news.title }}
                </h4>

                <p class="text-sm text-gray-600 mb-3 line-clamp-2">
                    {{ news.description }}
                </p>

                <div class="flex items-center justify-between">
                    <div class="flex items-center text-sm text-gray-500">
                        <font-awesome-icon icon="fa-solid fa-calendar" class="mr-1"></font-awesome-icon>
                        <span>{{ news.dateRange }}</span>
                    </div>

                    <div class="flex items-center gap-2">
                        <button @click="viewDetails"
                            class="text-primary hover:text-primary-dark text-sm font-medium transition-colors duration-200">
                            View Details
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "news-calendar-card",
    props: {
        news: {
            type: Object,
            required: true
        }
    },
    methods: {
        getTypeColor(type) {
            const colors = {
                'announcement': 'bg-blue-100 text-blue-800',
                'event': 'bg-green-100 text-green-800',
                'conference': 'bg-purple-100 text-purple-800',
                'update': 'bg-yellow-100 text-yellow-800',
                'news': 'bg-gray-100 text-gray-800'
            };
            return colors[type] || colors['news'];
        },
        getTypeLabel(type) {
            const labels = {
                'announcement': 'Announcement',
                'event': 'Event',
                'conference': 'Conference',
                'update': 'Update',
                'news': 'News'
            };
            return labels[type] || 'News';
        },
        viewDetails() {
            // Emit event to parent component or handle navigation
            this.$emit('view-details', this.news);
        }
    }
}
</script>

<style lang="scss" scoped>
.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
